import { axiosInstance } from '../clients/axiosClient';
import { API_V1_PREFIX } from '../utils/constants';

export type TaskStatus = 'scheduled' | 'cancelled' | 'executed';

export interface ScheduledTaskDto {
  schedule_id: string;
  task_name?: string | null;
  task_args?: any[] | null;
  task_kwargs?: Record<string, any> | null;
  entity_type: string;
  entity_id: string;
  task_type: string;
  scheduled_at: string;
  status: TaskStatus;
}

export interface ListSchedulesParams {
  status_filter?: TaskStatus;
  scheduled_from?: string;
  scheduled_to?: string;
  entity_type?: string;
  entity_id?: string;
  task_type?: string;
  limit?: number;
  offset?: number;
}

export const listSchedules = async (
  params: ListSchedulesParams
): Promise<ScheduledTaskDto[]> => {
  const { data } = await axiosInstance.get<ScheduledTaskDto[]>(
    `${API_V1_PREFIX}system/taskiq/schedules`,
    { params }
  );
  return data;
};

export const listOverdueSchedules = async (
  minutes_overdue = 60,
  limit = 100
): Promise<ScheduledTaskDto[]> => {
  const { data } = await axiosInstance.get<ScheduledTaskDto[]>(
    `${API_V1_PREFIX}system/taskiq/overdue`,
    { params: { minutes_overdue, limit } }
  );
  return data;
};

export const cancelSchedule = async (scheduleId: string) => {
  const { data } = await axiosInstance.post(
    `${API_V1_PREFIX}system/taskiq/schedules/${scheduleId}/cancel`
  );
  return data;
};

export const cancelSchedulesBulk = async (schedule_ids: string[]) => {
  const { data } = await axiosInstance.post(
    `${API_V1_PREFIX}system/taskiq/schedules/cancel`,
    { schedule_ids }
  );
  return data;
};

export const runNow = async (scheduleId: string) => {
  const { data } = await axiosInstance.post(
    `${API_V1_PREFIX}system/taskiq/schedules/${scheduleId}/run-now`
  );
  return data;
};

